export default __webpack_public_path__ + "static/media/gq.676da5d4.svg";